import { useEffect, useState } from "react";
import { MOBILE_VIEWPORT_MEDIA_QUERY } from "../utils/viewportBreakpoints";

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(MOBILE_VIEWPORT_MEDIA_QUERY).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_VIEWPORT_MEDIA_QUERY);
    const handler = (e) => setIsMobile(e.matches);

    // Modern browsers
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return isMobile;
}
